var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.$emit('submit', _vm.value);
      }
    }
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Turma",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.value.nomeDaTurma,
      callback: function ($$v) {
        _vm.$set(_vm.value, "nomeDaTurma", $$v);
      },
      expression: "value.nomeDaTurma"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Ano/Série",
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.listAnoSeries
    },
    model: {
      value: _vm.value.anoSerie,
      callback: function ($$v) {
        _vm.$set(_vm.value, "anoSerie", $$v);
      },
      expression: "value.anoSerie"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Turno",
      "item-text": "descricao",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.listTurnos
    },
    model: {
      value: _vm.value.turno,
      callback: function ($$v) {
        _vm.$set(_vm.value, "turno", $$v);
      },
      expression: "value.turno"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "GRE",
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.listGres
    },
    on: {
      "change": _vm.handleGreChange
    },
    model: {
      value: _vm.value.gre,
      callback: function ($$v) {
        _vm.$set(_vm.value, "gre", $$v);
      },
      expression: "value.gre"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Município",
      "item-text": "nome",
      "item-value": "codigo",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.filteredListMunicipios
    },
    on: {
      "change": _vm.handleMunicipioChange
    },
    model: {
      value: _vm.value.municipio,
      callback: function ($$v) {
        _vm.$set(_vm.value, "municipio", $$v);
      },
      expression: "value.municipio"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Escola",
      "item-text": "local",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.lists.filteredListEscolas
    },
    on: {
      "change": _vm.handleEscolasChange
    },
    model: {
      value: _vm.value.escola,
      callback: function ($$v) {
        _vm.$set(_vm.value, "escola", $$v);
      },
      expression: "value.escola"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-submit-button'), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }